var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 34,
    viewBox: "0 0 26 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_423_554)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.7786,
    cy: 26.1111,
    r: 3.8889,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.7786,
    cy: 26.1111,
    r: 3.3889,
    stroke: "#9C9C9C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3611 11.1114C22.3611 18.8892 12.7777 25.5559 12.7777 25.5559C12.7777 25.5559 3.19434 18.8892 3.19434 11.1114C3.19434 8.45919 4.20401 5.91564 6.00124 4.04027C7.79847 2.1649 10.236 1.11133 12.7777 1.11133C15.3194 1.11133 17.7569 2.1649 19.5542 4.04027C21.3514 5.91564 22.3611 8.45919 22.3611 11.1114Z",
    fill: "#F95757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7778 15.5554C15.1302 15.5554 17.0371 13.5656 17.0371 11.111C17.0371 8.65636 15.1302 6.6665 12.7778 6.6665C10.4255 6.6665 8.51855 8.65636 8.51855 11.111C8.51855 13.5656 10.4255 15.5554 12.7778 15.5554Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_423_554",
    x: 5.88965,
    y: 20.2222,
    width: 13.7773,
    height: 13.7778,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.53 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_423_554"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_423_554",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMarker);
export default __webpack_public_path__ + "static/media/new_marker.287a93001a5b85b4c8411e16c074206b.svg";
export { ForwardRef as ReactComponent };